import { show_toast, hide_toast, get_toast_content, show_help } from './types';

let timeout = null;

export const showToast = (content, time = null, left = false) => {
  return async (dispatch, getState) => {
    const { shown } = getState().toastStore;
    // if already shown and going to hide, hide/clearTimeout, then show again
    if (shown && timeout) {
      clearTimeout(timeout);
      dispatch(hideToast());
      timeout = setTimeout(() => {
        dispatch({ type: get_toast_content, payload: content });
        dispatch({ type: show_toast, payload: left });
      }, 1000);
    }
    // if toast is not shown or if it needs to be manually cleared
    else {
      await dispatch({ type: get_toast_content, payload: content });
      dispatch({ type: show_toast, payload: left });
    }
    // after having shown the toast, if there is a time specified, set a time to clear it
    if (time) {
      timeout = setTimeout(() => {
        clearTimeout(timeout);
        dispatch({ type: hide_toast });
      }, time);
    }
  };
};

export const hideToast = () => {
  clearTimeout(timeout);
  return { type: hide_toast };
};

export const showHelp = () => {
  return { type: show_help };
};


// WEBPACK FOOTER //
// ./src/actions/ToastActions.js